import type { BariPostCaroInactivityReportData } from '@common/validation/customControls/bariPost/bariPostCaroInactivityPoliReport/v1/bariPostCaroInactivityPoliReportSchemaV1';

export const initialData: BariPostCaroInactivityReportData = {
    verslag: null,
    vervolgstap: null,
};
